<template>
  <body class="contents">
    <div>
      <img src="../../static/re-back.png" style="width: 40px; height: 40px; position:absolute; left: 12px; top: 12px" alt="" @click = "reBack">
    </div>
    <div class="head">
      <div class="head-top">
        <div class="title">购销订单系统</div>
      </div>
    </div>
    <div class="contents-body">
      <div class="head-login">
        <div class="login">
          <div style="width: 22%;">账号：</div>
          <div><input type="text" v-model="form.account" placeholder="请输入账号" class="app-input" /></div>
        </div>
        <div class="login">
          <div style="width: 22%;">密码：</div>
          <div><input type="password" v-model="form.password" placeholder="请输入密码" class="app-input" /></div>
        </div>
      </div>
      <div class="remember-password">
        <div>
          <el-checkbox-group class="app-list" @change="checkboxChange" v-model="password">
            <label class="app-list-cell app-list-cell-pd">
              <el-checkbox label="记住密码" >记住密码</el-checkbox>
            </label>
          </el-checkbox-group>
        </div>
      </div>
      <div class="sign-in">
        <el-button class="logins" type="primary" @click="login">登&nbsp;&nbsp;&nbsp; 入</el-button>
      </div>
    </div>
  </body>
</template>

<script>

export default {
  name: 'Login',
  data () {
    return {
      form: {
        account: '',
        password: ''
      },
      password: false
    }
  },
  created () {
  },
  mounted () {
    this.checkRemember()
  },
  methods: {
    checkRemember () {
      const remember = localStorage.getItem('remember')
      if (remember === 'true') {
        this.form.account = localStorage.getItem('account')
        this.form.password = localStorage.getItem('password')
        this.password = true
      } else {
        localStorage.removeItem('account')
        localStorage.removeItem('password')
        this.password = false
      }
    },
    reBack () {
      this.$router.push({ name: 'Home' })
    },
    login () {
      try {
        this.$api.login(this.form).then(response => {
          if (response.code === 200) {
            if (this.password === true) {
              localStorage.setItem('account', this.form.account)
              localStorage.setItem('password', this.form.password)
            }
            if (this.form.password === '123456') {
              const confirmResult = confirm('由于您的密码过于简单，请修改后再登录')
              if (confirmResult) {
                this.$router.push({ name: 'Password' })
              }
            } else {
              localStorage.setItem('token', response.data.token)
              let page = localStorage.getItem('page')
              if (page !== null && page !== '') {
                this.$router.push({ name: page })
              }
            }
          } else {
            this.msgError('登录失败,请重试...')
          }
        })
      } catch (error) {
        console.error('Login error:', error)
      }
    },
    checkboxChange (value) {
      localStorage.setItem('remember', value.toString())
    }
  }
}
</script>

<style scoped>
.contents{
  width: 100%;
  height: 100vh;
  background-color: #f3efde;
  font-size: 14px;
  line-height: 1.8;
}

.head{
  display: flex;
  height: 175px;
}

.head-top{
  margin: auto;
}

.title{
  font-size: 22px;
  color: #b58c5a;
  font-weight: 600;
}

.head-login {
  margin-top: 25px;
}

.login {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  width: 80%;
  margin: 10px auto 0;
  background-color: #e0d4bb;
}

.login>div {
  font-size: 15px;
  margin: 9px 0 0 15px;
  line-height: 1.8;
  display: block;
}

.login>div input {
  margin-top: 2px;
  display: block;
  font-size: 16px;
  line-height: 1.4em;
  height: 1.4em;
  min-height: 1.4em;
  overflow: hidden;
}

.app-input{
  background-color: initial;
  color: inherit;
  text-shadow: inherit;
  outline-color: initial;
  border-color: initial;
  text-decoration-color: inherit;
  position: relative;
  display: block;
  height: 100%;
  background: none;
  opacity: 1;
  font: inherit;
  line-height: inherit;
  letter-spacing: inherit;
  text-align: inherit;
  text-indent: inherit;
  text-transform: inherit;
  width: 100%;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  text-decoration: inherit;
}

.remember-password{
  width: 80%;
  margin: auto;
}

.remember-password div{
  margin-left: 15px;
  line-height: 50px;
}

.app-list{
  background-color: unset;
  position: static !important;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.app-list-cell{
  padding: 7px 0 !important;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.app-list /deep/ .el-checkbox .el-checkbox__inner {
  width: 24px;
  height: 24px;
}

.sign-in .el-button {
  width: 70%;
  border-radius: 15px !important;
  border: none;
  color: #fff;
  font-weight: 600;
  line-height: 1.3;
  font-size: 18px;
}

.logins {
  margin: 10px auto;
  background-color: #f0b78e !important;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/Login.vue